import React, { useState } from "react";
import api from "../../../../services/api";
import { showBasicAlert } from "../../../../core/common/useAlert";
import { DriveItem, FileTypeCount } from "../types";
import { EMPTY_FILE_COUNT } from "../constants";

interface FileCounts {
  myfolder: FileTypeCount;
  shared: FileTypeCount;
  official: FileTypeCount;
}

interface FileModalProps {
  currentFolderId: number | null;
  setQuickAccessItems: React.Dispatch<React.SetStateAction<DriveItem[]>>;
  setFileCounts: React.Dispatch<React.SetStateAction<FileCounts>>;
}

const FileModal: React.FC<FileModalProps> = ({
  currentFolderId,
  setQuickAccessItems,
  setFileCounts,
}) => {
  const [folderName, setFolderName] = useState<any>("");
  const signature = localStorage.getItem("signature");

  const handleFolderSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!folderName.trim()) {
      showBasicAlert("Please enter a folder name.");
      return;
    }

    try {
      const payload = {
        signature,
        name: folderName.trim(),
        type: 1, // Folder type
        mime_type: "folder",
        parent_id: currentFolderId || null,
        size: 0,
        path: `/${folderName.trim()}/`,
        status: 1,
        document_type: null,
      };

      const response = await api.post("driveService/addDriveItem", payload);
      const result = response.data?.message?.[0];

      showBasicAlert(result?.msg || "Folder created.");
      if (result?.status) {
        setFolderName("");
      }
      let updateResponse;

      if (currentFolderId) {
        const data = {
          signature: signature,
          parent_id: currentFolderId,
        };
        updateResponse = await api.post("driveService/getAllDriveItems", data);
      } else {
        updateResponse = await api.post("driveService/getFirstFile", {
          signature,
        });
      }

      const items = updateResponse.data.message[0].data;

      setQuickAccessItems(items);
      const [
        getFileTypeCounts,
        getSharedFileTypeCounts,
        getOfficialFileTypeCounts,
      ] = await Promise.all([
        api.post("driveService/getFileTypeCounts", { signature }),
        api.post("driveService/getSharedFileTypeCounts", { signature }),
        api.post("driveService/getOfficialFileTypeCounts", { signature }),
      ]);
      setFileCounts({
        myfolder: getFileTypeCounts?.data?.data?.data || { ...EMPTY_FILE_COUNT },
        shared:
          getSharedFileTypeCounts?.data?.data?.data || { ...EMPTY_FILE_COUNT },
        official:
          getOfficialFileTypeCounts?.data?.data?.data || { ...EMPTY_FILE_COUNT },
      });
    } catch (error: any) {
      console.error("Error creating folder:", error);
      showBasicAlert(error?.data?.message?.[0]?.msg || "Something went wrong.");
    }
  };

  return (
    <>
      {/* Create Folder */}
      <div className="modal fade" id="add_folder">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Create Folder</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleFolderSubmit}>
              <div className="modal-body">
                <div className="mb-0">
                  <label className="form-label">Folder Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={folderName}
                    onChange={(e) => setFolderName(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Add New Folder
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FileModal;
